<template>
  <div>
    <div
      class="xdf-city-mask animated fadeIn"
      ref="xdf-city-mask"
      v-show="maskshow"
    >
      <div class="city-mask-content">
        <h3 class="city-mask-title">
          <a class="close" title="关闭"></a
          >欢迎来到新东方，请选择合适的新东方学校所在地
        </h3>
        <div class="city-mask-detail">
          <div class="goback">
            <img
              src="http://images.xdf.cn/cms20150819/zuixinban/images/cnz.png?20190410"
            />
            <p>
              猜你所在
              <!-- <a class="gobackBtn" :cid="currCity.cid" :href="currCity.url" >{{ currCity.city }}</a> -->
              <a class="gobackBtn" :cid="currCity.cid">{{ currCity.city }}</a>
              <span class="sureBtn" @click="setCurrCity" :href="currCity.url"
                >确定</span
              >
            </p>
          </div>
          <div class="city-mask-list">
            <ul v-show="cityList_L">
              <li v-for="(cityInfo, key) in cityList_L" :key="key">
                <span>{{ key.toUpperCase() }}</span>
                <em>
                  <a
                    v-for="(city, index) in cityInfo"
                    :key="index"
                    :cid="city.Id"
                    @click="selectCity(city.Id, city.Name)"
                    >{{ city.Name }}</a
                  >
                </em>
              </li>
            </ul>
            <ul v-show="cityList_R">
              <li v-for="(cityInfo, key) in cityList_R" :key="key">
                <span>{{ key.toUpperCase() }}</span>
                <em>
                  <a
                    v-for="(city, index) in cityInfo"
                    :key="index"
                    :cid="city.Id"
                    @click="selectCity(city.Id, city.Name)"
                    >{{ city.Name }}</a
                  >
                </em>
              </li>
            </ul>
          </div>
          <div class="city-mask-zhusu">
            <a
              href="http://souke.xdf.cn/Search.aspx?cid=1&gc=0&v=5&ccc=154&attr=308"
              >北京住宿班</a
            >
            <a href="http://souke.xdf.cn/Search.aspx?cid=2&ccc=154"
              >上海住宿班</a
            >
          </div>
        </div>
      </div>
    </div>
    <city-select
      :cityList="cityList"
      :cityList_L="cityList_L"
      :cityList_R="cityList_R"
      :hotKeyWords="hotKeyWords"
    ></city-select>
  </div>
</template>

<script>
import $ from "jquery";
import jsonp from "js/jsonp.js";
import { objKeySort } from "js/compare.js";
import { getAllCity } from "js/getSoukeData.js";
import CitySelect from "./Cityselect";
export default {
  name: "Citymask",
  components: {
    CitySelect,
  },
  props: ["hotKeyWords"],
  data() {
    return {
      currCity: Object,
      maskshow: true,
      cityList: {},
      cityList_L: {},
      cityList_R: {},
    };
  },
  created() {
    $("html").scrollTop(0);
    this.getCurrCity();
    this.getCityInfo();
    if (this.$cookies.get("soukecityid")) {
      this.maskshow = false;
      $("html").css({ "overflow-y": "auto" });
    } else {
      this.maskshow = true;
      $("html").css({ "overflow-y": "hidden" });
    }
  },
  watch: {
    maskshow(newVal) {
      if (newVal) {
        $("html").css({ "overflow-y": "hidden" });
      } else {
        $("html").css({ "overflow-y": "auto" });
      }
    },
  },
  methods: {
    getCurrCity() {
      jsonp(
        "http://cmsdt.xdf.cn/xdf_app/index.php",
        {
          c: "soukeapi",
          m: "chooseUrl",
          callback: "callback",
        },
        { timeout: 2000 }
      ).then(
        (response) => {
          if (response.cid == "0" || response.city == null) {
            response = {
              cid: "1",
              city: "北京",
              msg: "0",
              url: "http://www.xdf.cn/",
            };
          }
          this.currCity = response;
          this.$store.commit("setCurrCity", response);
        },
        () => {}
      );
    },
    setCurrCity() {
      if (this.$route.query.redirectUrl) {
        window.location.replace(
          this.$route.query.redirectUrl.replace("{cityId}", cid)
        );
        return;
      }
      this.maskshow = false;
      let cid = this.currCity.cid;
      let cname = this.currCity.city;
      $("html").css({ "overflow-y": "auto" });
      this.$store.commit("selectCity", { cid, cname });
      this.$cookies.set("soukecityid", cid, "14d", "/", ".xdf.cn");
      this.$cookies.set("cityName", cname, "14d", "/", ".xdf.cn");
    },
    selectCity(cid, cname) {
      if (this.$route.query.redirectUrl) {
        window.location.replace(
          this.$route.query.redirectUrl.replace("{cityId}", cid)
        );
        return;
      }
      this.$store.commit("selectCity", { cid, cname });
      this.$cookies.set("soukecityid", cid, "14d", "/", ".xdf.cn");
      this.$cookies.set("cityName", cname, "14d", "/", ".xdf.cn");
      this.maskshow = false;
    },
    getCityInfo() {
      getAllCity().then(
        (response) => {
          response.forEach((item) => {
            let Alphabet = item.EnglishName.substr(0, 1);
            if (this.cityList[Alphabet] === undefined) {
              this.cityList[Alphabet] = [];
            }
            this.cityList[Alphabet].push(item);
          });
          this.cityList = objKeySort(this.cityList);
          for (let alpha in this.cityList) {
            if (alpha.charCodeAt() < 109) {
              this.cityList_L[alpha] = this.cityList[alpha];
            } else {
              this.cityList_R[alpha] = this.cityList[alpha];
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.xdf-city-mask
  top: 0
  bottom: 0
  left: 0
  right: 0
  z-index: 99999
  position: fixed
  background-color: rgba(0, 0, 0, .7)
  .city-mask-content
    display: flex
    position: fixed
    flex-direction: column
    width: 648px
    top: 50%
    left: 50%
    margin-left: -324px
    margin-top: -238px
    border-radius: 6px
    .city-mask-title
      background: $themeColor
      height: 46px
      line-height: 46px
      color: #fff
      font-size: 22px
      font-weight: normal
      text-align: center
    .city-mask-detail
      flex: 1
      background: #fff
      min-height: 390px
      padding: 0 32px
      .goback
        height: 40px
        margin: auto
        line-height: 40px
        position: relative
        img
          position: absolute
          width: 18px
          height: 20.22px
          top: 10px
          left: 2px
        p
          margin-left: 24px
          font-size: 14px
          color: $themeColor
          .gobackBtn
            padding: 0 4px
            color: #38bca4
            &:hover
              color: #009a61
          .sureBtn
            color: white
            background: $themeColor
            margin-left: 10px
            padding: 2px 5px
            cursor: pointer
            border-radius: 6px
            font-size: 12px
            opacity: .85
            &:hover
              opacity: 1
    .city-mask-list
      display: flex
      height: 340px;
      overflow: hidden;
      padding-bottom: 10px
      border-top: 1px solid #ccc
      border-bottom: 1px solid #ccc
      ul
        flex: 1
        color: $themeColor
        li
          padding-left: 14px
          position: relative
          min-height: 28px
          line-height: 28px
          span
            position: absolute
            left: 0
            font-size: 16px
            font-family: Consolas
          em
            vertical-align: middle
            a
              color: #7f7f7f
              font-size: 12px
              padding: 0px 4px
              line-height: 20px
              border-radius: 6px
              cursor: pointer
              &:hover
                background: $themeColor
                color: #fff
    .city-mask-zhusu
      height: 40px
      line-height: 40px
      a
        color: orangered
        font-size: 14px
        padding: 0 10px
</style>



// WEBPACK FOOTER //
// src/common-components/Citymask.vue